// extracted by mini-css-extract-plugin
module.exports = {"ForeignObject":"GraphTooltip_ForeignObject__3F4Pk","Root":"GraphTooltip_Root__3tZRU","Row":"GraphTooltip_Row__eLUWI"};